/* eslint-disable */
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData } from "utils/Gateway";
// import use translation ------------------------------
import { useTranslation } from "react-i18next";
//import context
import { GlobalProvider } from "context/GlobalContext";
import { ecosystemSlug } from "Config/Config";

const RegisterModal = () => {
  const fullURL = window.location.href;

  const parsedURL = new URL(fullURL);
  const searchParams = parsedURL.searchParams;

  const refParam = searchParams.get("refcode");

  const { createAccountMessage, setcreateAccountMessage, setuserEmailforOtp } =
    useContext(GlobalProvider);

  const { t } = useTranslation(); // translation marker
  /*----- UseState to send username and password for Login ----*/
  const [userName, setuserName] = useState("");
  const [userSurname, setuserSurname] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isAgreeTerms, setIsAgreeTerms] = useState(false);
  const [isAgreeTermsCookies, setIsAgreeTermsCookies] = useState(false);
  const [isSubscribeCommercialMail, setIsSubscribeCommercialMail] =
    useState(false);

  const [responseMessage, setResponseMessage] = useState("");

  /* Hook for validation start */
  const [validation, setValidation] = useState({
    firstNameWarning: false,
    lastNameWarning: false,
    emailWarning: false,
    validEmailWarning: false,
    passwordWarning: false,
    agreeTermsWarning: false,
    agreeCookiesWarnig: false,
  });
  /* Hook for validation end */

  // validation function
  const formValidation = () => {
    let isValid = true;

    if (userName === "") {
      setValidation((prevState) => ({ ...prevState, firstNameWarning: true }));
      isValid = false;
    }

    if (userSurname === "") {
      setValidation((prevState) => ({ ...prevState, lastNameWarning: true }));
      isValid = false;
    }

    if (userEmail === "") {
      setValidation((prevState) => ({ ...prevState, emailWarning: true }));
      isValid = false;
    } else {
      setValidation((prevState) => ({ ...prevState, emailWarning: false }));
      const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!mailformat.test(userEmail)) {
        setValidation((prevState) => ({
          ...prevState,
          validEmailWarning: true,
        }));
        isValid = false;
      } else {
        setValidation((prevState) => ({
          ...prevState,
          validEmailWarning: false,
        }));
      }
    }

    if (userPassword === "") {
      setValidation((prevState) => ({ ...prevState, passwordWarning: true }));
      isValid = false;
    }

    if (isAgreeTerms == false) {
      setValidation((prevState) => ({ ...prevState, agreeTermsWarning: true }));
      isValid = false;
    }

    if (isAgreeTermsCookies == false) {
      setValidation((prevState) => ({
        ...prevState,
        agreeCookiesWarnig: true,
      }));
      isValid = false;
    }

    return isValid;
  };

  // function for change text type
  const toggleText = () => {
    setShowPassword(!showPassword);
  };

  //function for sign up
  const signupHandler = async () => {
    if (formValidation()) {
      setIsLoading(true);

      try {
        let userData = {
          name: userName,
          surname: userSurname,
          email: userEmail,
          password: userPassword,
          subscribecommercialmail: isSubscribeCommercialMail ? "1" : "0",
        };

        if (refParam) {
          userData.mentorrefcode = refParam;
        }

        console.log("User data ------>", userData);

        let requestURL =
          url.API_BASE_URL +
          url.API_REGISTRATION +
          `?ecosystemslug=${ecosystemSlug}`;

        console.log("request url -->", requestURL);

        const response = await postData(requestURL, userData);

        console.log("response -->", response);

        setIsLoading(false);
        if (response.status) {
          setuserEmailforOtp(userEmail);
          resetRegisterData();
          //hide register modal
          let registerModal = document.querySelector("#register_mdl");
          let modal = bootstrap.Modal.getInstance(registerModal);
          modal.hide();

          //show otpconfirm modal
          let myModal = new bootstrap.Modal(
            document.getElementById("otp_confirm_login_mdl")
          );
          myModal.show();
        } else {
          setResponseMessage(response.message);
        }
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  // function for reset the useState containing the email and password text fields
  const resetRegisterData = () => {
    setuserName("");
    setuserSurname("");
    setUserEmail("");
    setUserPassword("");
    setIsAgreeTerms(false);
    setIsAgreeTermsCookies(false);
    setIsSubscribeCommercialMail(false);
    setValidation({
      firstNameWarning: false,
      lastNameWarning: false,
      emailWarning: false,
      validEmailWarning: false,
      passwordWarning: false,
      agreeTermsWarning: false,
      agreeCookiesWarnig: false,
    });
    setcreateAccountMessage("");
  };

  return (
    <div className="registration_modal">
      <div
        className="modal fade show"
        data-bs-backdrop="static"
        id="register_mdl"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            {/* ---- modal header section start ---- */}
            <div className="modal-header  justify-content-between position-relative">
              <div className="signin_hdng ">
                <h3>Register Account</h3>
              </div>
              <button
                type="button"
                className="close d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="material-icons-outlined">close</i>
              </button>
            </div>
            {/* ---- modal header section end ---- */}

            {/* ---- modal body section start ---- */}
            <div className="modal-body">
              <div className="login_body">
                {/* ----- register form section start ----- */}
                <form onSubmit={(e) => e.preventDefault()}>
                  {/* ----- first name,last name,email and password input section start ----- */}
                  <div className="login_fillOuter">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="input_fill login_inputfill">
                          <label>First Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={t("Enter First Name")}
                            value={userName}
                            onChange={(e) => {
                              setValidation((prevState) => ({
                                ...prevState,
                                firstNameWarning: false,
                              }));
                              setuserName(e.target.value);
                              setResponseMessage("");
                            }}
                          />
                          {validation.firstNameWarning && (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined me-2">
                                info
                              </span>
                              {t("Please enter first name")}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="input_fill login_inputfill">
                          <label>Last Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={t("Enter Last Name")}
                            value={userSurname}
                            onChange={(e) => {
                              setValidation((prevState) => ({
                                ...prevState,
                                lastNameWarning: false,
                              }));
                              setuserSurname(e.target.value);
                              setResponseMessage("");
                            }}
                          />
                          {validation.lastNameWarning && (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined me-2">
                                info
                              </span>
                              {t("Please enter last name")}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input_fill login_inputfill">
                          <label>Email</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder={t("Enter Email")}
                            value={userEmail}
                            onChange={(e) => {
                              setValidation((prevState) => ({
                                ...prevState,
                                emailWarning: false,
                                validEmailWarning: false,
                              }));
                              setUserEmail(e.target.value);
                              setResponseMessage("");
                            }}
                          />
                          {/* ------ email warning start ------ */}
                          {validation.emailWarning && (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined me-2">
                                info
                              </span>
                              {t("Please enter email")}
                            </p>
                          )}
                          {/* ----- valid email warning ------ */}
                          {validation.validEmailWarning && (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined me-2">
                                info
                              </span>
                              {t("Please enter valid email")}
                            </p>
                          )}
                          {/* ------ email warning end ------ */}

                          {/* ----- create and signin section end ----- */}
                          {responseMessage === "" ? null : (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined me-2">
                                info
                              </span>
                              {responseMessage}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input_fill login_inputfill">
                          <label>Password</label>
                          <div className="eye_btnfill position-relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              placeholder={t("Enter Password")}
                              value={userPassword}
                              onChange={(e) => {
                                setValidation((prevState) => ({
                                  ...prevState,
                                  passwordWarning: false,
                                }));
                                setUserPassword(e.target.value);
                              }}
                            />
                            <Link
                              to="#"
                              className="copy_link"
                              onClick={toggleText}
                            >
                              <span className="material-icons-outlined">
                                {" "}
                                visibility
                              </span>
                            </Link>
                          </div>
                          {validation.passwordWarning && (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined me-2">
                                info
                              </span>
                              {t("Please enter password")}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ----- first name,last name,email and password input section end ----- */}

                  {/* ----- agree checkbox section start ----- */}
                  <div className="create_chk_outer">
                    <div className="form-check p-0 d-flex  gap-2 m-0 cursor-pointer  mb-3">
                      <input
                        className="form-check-input d-block m-0 mt-1"
                        type="checkbox"
                        checked={isAgreeTerms}
                        onChange={(e) => {
                          setValidation((prevState) => ({
                            ...prevState,
                            agreeTermsWarning: false,
                          }));
                          setIsAgreeTerms(e.target.checked);
                        }}
                      />
                      <label
                        className="form-check-label d-block text-gray cursor-pointer"
                        htmlFor="overdue"
                      >
                        By clicking on this box I agree with Spain Startup's{" "}
                        <Link to="#" className="text-pink">
                          Terms & Conditions
                        </Link>
                      </label>
                    </div>

                    {validation.agreeTermsWarning && (
                      <p className="text-pink mb-3">
                        <span className="material-icons-outlined me-2">
                          info
                        </span>
                        Please Agree with the Terms and Condition
                      </p>
                    )}
                    <div className="form-check p-0 d-flex  gap-2 m-0 cursor-pointer  mb-3">
                      <input
                        className="form-check-input d-block m-0 mt-1"
                        type="checkbox"
                        checked={isAgreeTermsCookies}
                        onChange={(e) => {
                          setIsAgreeTermsCookies(e.target.checked);
                          setResponseMessage("");
                          setValidation((prevState) => ({
                            ...prevState,
                            agreeCookiesWarnig: false,
                          }));
                        }}
                      />
                      <label
                        className="form-check-label d-block text-gray cursor-pointer"
                        htmlFor="overdue"
                      >
                        I have read and accept the{" "}
                        <Link to="#" className="text-pink">
                          privacy and cookies policy
                        </Link>
                      </label>
                    </div>

                    {validation.agreeCookiesWarnig && (
                      <p className="text-pink mb-2">
                        <span className="material-icons-outlined me-2">
                          info
                        </span>
                        Please Agree with the privacy and cookies policy
                      </p>
                    )}
                    <div className="form-check p-0 d-flex  gap-2 m-0 cursor-pointer mb-3">
                      <input
                        className="form-check-input d-block m-0 mt-1"
                        type="checkbox"
                        checked={isSubscribeCommercialMail}
                        onChange={(e) => {
                          setIsSubscribeCommercialMail(e.target.checked);
                          setResponseMessage("");
                        }}
                      />
                      <label
                        className="form-check-label d-block text-gray cursor-pointer"
                        htmlFor="overdue"
                      >
                        I agree to receive advertising, promotional or
                        interesting information in relation to the activity of
                        Spain Startup. I am informed that I may revoke this
                        authorization at any time.
                      </label>
                    </div>
                  </div>
                  {/* ----- agree checkbox section end ----- */}

                  {/* ----- create and signin section start ----- */}
                  <div className="signup_btns_outer d-flex align-items-center justify-content-between mt-4">
                    <div className="d-flex align-items-center">
                      {" "}
                      <div className="trms_check me-2">
                        <label className="radio-check">
                          <p>Already have an account ?</p>
                        </label>
                      </div>
                      <div className="forgot_btn">
                        <Link
                          to="#"
                          className=""
                          data-bs-toggle="modal"
                          data-bs-dismiss="modal"
                          data-bs-target="#login_modal"
                        >
                          Sign In
                        </Link>
                      </div>
                    </div>

                    {/* ----- register button start ----- */}
                    <button
                      type="button"
                      className="btn primary-btn"
                      onClick={signupHandler}
                      disabled={isLoading ? true : false}
                      style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
                    >
                      {t("Sign Up")}
                      {isLoading && (
                        <div
                          className="mx-2 spinner-border spinner-border-sm"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                    </button>
                    {/* ----- register button end ----- */}
                  </div>
                  {/* ----- create and signin section end ----- */}
                </form>
                {/* ----- register form section end ----- */}
              </div>
            </div>
            {/* ---- modal body section end ---- */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;
